<template>
    <div>
        <div class="horizontal-container">
            <div class="tree-container">
                <template v-for="node in roleTypeNodes">
                    <div :class="{ 'tree-node': true, 'selected-tree-node': node.value == selectedNode }"
                         @click="selectNode(node.value)">
                        {{'&nbsp;'.repeat(node.level*4)}}&boxur;{{node.value.displayName}}
                    </div>
                </template>
            </div>
            <div>
                <form-wrapper form-title="Details">
                    <template v-for="child in selectedNode.children">
                        <template v-if="child.subclass === 'leaf'">
                            <form-text-input :caption="child.displayName"
                                             v-if="child.type == 'STRING'"
                                             v-model="valueForModel(child.path.elements)[child.systemName]"
                                            :required="child.required"/>
                            <form-date-input :caption="child.displayName"
                                             v-if="child.type == 'DATE'"
                                             v-model="valueForModel(child.path.elements)[child.systemName]"
                                             :required="child.required"/>
                            <form-number-input :caption="child.displayName"
                                               v-if="child.type == 'NUMBER'"
                                               v-model="valueForModel(child.path.elements)[child.systemName]"
                                               :required="child.required"/>
                            <form-checkbox-input :caption="child.displayName"
                                             v-if="child.type == 'BOOLEAN'"
                                             v-model="valueForModel(child.path.elements)[child.systemName]"
                                             :required="child.required"/>

                        </template>
                    </template>
                </form-wrapper>
            </div>
        </div>
    </div>
</template>

<script>
    import FormWrapper from "../../components/form/FormWrapper";
    import FormTextInput from "../../components/form/FormTextInput";
    import FormDateInput from "../../components/form/FormDateInput";
    import FormNumberInput from "../../components/form/FormNumberInput";
    import SmallIconButton from "../../components/button/SmallIconButton";
    import FormCheckboxInput from "../../components/form/FormCheckboxInput";
    export default {
        name: "PartyRolePart",
        components: {FormCheckboxInput, SmallIconButton, FormNumberInput, FormDateInput, FormTextInput, FormWrapper},
        props: {
            partyRoleType: Object,
            value: Object
        },
        computed: {
            roleTypeNodes() {
                let processChildren = (node, level, nodeList) => {
                    if(node.children == undefined) return;
                    node.children.forEach(child => {
                        if(child.subclass == 'composite') {
                            nodeList.push({ value: child, level });
                            processChildren(child, ++level, nodeList);

                        }
                    })
                }
                let root = [{ value: this.partyRoleType.attributeDescriptor, level: 0 }];
                processChildren(this.partyRoleType.attributeDescriptor, 1, root);
                return root;
            }
        },
        methods: {
            valueForModel(path) {
                let cPath = [ ... path];
                cPath.length = cPath.length - 1;
                let result = cPath.reduce((prev, curr) => {
                    if(typeof prev[curr] == 'undefined') {
                        prev[curr] = {}
                    }
                    return prev[curr];
                }, this.value.attributeComponent.values)
                return result
            },
            selectNode(node) {
                this.selectedNode = node;
            },
            emitDelete() {
                this.$emit('delete', this.value);
            }
        },
        watch: {
            value: {
                handler() {
                    this.selectNode(this.partyRoleType.attributeDescriptor);
                },
                immediate: true
            }
        },
        data: function () {
            return {
                selectedNode: null
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/global";

.horizontal-container {
    display: grid;
    grid-template-columns: 150px auto;
}

.tree-container {
    color: lighten($navigationGray, 40);
}

.selected-tree-node {
    font-weight: bold;
}

.tree-node {
    cursor: pointer;
}

.tree-node:hover {
    color: lighten($navigationGray, 60);
}
</style>